import * as queries from "./query";
import Service from "@services/Service";

export default { ...new Service({ queries }) };
